import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GridAuditCellsService {
  constructor(private http: HttpClient) {}

  getCellAuditByContext(baseUrl: string, params: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/getAuditCellByContext`, params, { withCredentials: true });
  }
}
